import { normalizeInternetMessageId } from './inboundReply.js';
export function replySubjectLine(subject) {
    const t = (subject ?? '').trim();
    if (!t)
        return 'Re:';
    if (/^re:\s/i.test(t))
        return t;
    return `Re: ${t}`;
}
/** SMTP In-Reply-To / References for a reply to a stored message. */
export function buildOutboundReplyHeaders(parent) {
    const parentId = parent.internet_message_id
        ? normalizeInternetMessageId(parent.internet_message_id)
        : null;
    if (!parentId)
        return { inReplyTo: null, references: [] };
    const refs = [];
    if (parent.in_reply_to) {
        const prior = normalizeInternetMessageId(parent.in_reply_to);
        if (prior)
            refs.push(prior);
    }
    refs.push(parentId);
    return { inReplyTo: parentId, references: [...new Set(refs)] };
}
//# sourceMappingURL=replyCompose.js.map